import { defaultTaxPayerInfoState } from './module-taxpayerinfo-state';

export default {
	resetState(state) {
		Object.assign(state, defaultTaxPayerInfoState);
	},
	setTaxPayerInfo(state, payload) {
		state.taxPayerInfo = payload;
	},
	updateViewGuide(state, res) {
		state.taxPayerInfo.IsViewGuide = res;
	},
	updateIsViewGuideUser(state, res) {
		state.IsViewGuideUser = res;
	},
	updateRemoteSigning(state, res) {
		state.taxPayerInfo.IsUseRemoteSigning = res.IsUseRemoteSigning;
	},
	updateIsUpdateAdminArea(state, res) {
		state.taxPayerInfo.IsUpdateAdminArea = true;
	},
	setCqtPopupDismissed(state, value) {
		state.cqtPopupDismissed = value;
	},
	/**
	 * Đánh dấu trạng thái chuyển đổi AMIS của MST làm việc (state đơn nguồn)
	 * Dùng bởi: activateAmisConvert (Processing), push-handler SignalR (Converted/Failed)
	 */
	updateAmisConvertStatus(state, value) {
		if (state.taxPayerInfo) {
			state.taxPayerInfo.AmisConvertStatus = value;
		}
	},
	/**
	 * Đánh dấu đã show messagebox lỗi convert AMIS trong phiên đăng nhập hiện tại
	 * Reset về false khi resetState (logout/đổi MST) → show lại ở phiên mới
	 */
	setAmisConvertFailNotiShown(state, value) {
		state.amisConvertFailNotiShown = value;
	}
};
